import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { getBlob, generatePrintUrl } from "../ajax";

export default ({
  match: {
    params: { key },
  },
}) => {
  const [redirectUrl, setRedirectUrl] = useState("");

  useEffect(() => {
    getBlob(key).then((content) =>
      setRedirectUrl(generatePrintUrl(content, false))
    );
  }, [key]);

  if (redirectUrl) {
    return <Redirect to={redirectUrl} />;
  }

  return null;
};
